<script lang="ts">
	import { fade } from "svelte/transition";
	import { onMount, onDestroy } from "svelte";

	const taglines = [
		"Crafted by Artificer Innovations, LLC",
		"Conjured by Artificer Innovations, LLC",
		"Forged by Artificer Innovations, LLC",
		"Brought to life by Artificer Innovations, LLC",
		"An Artificer Innovations, LLC creation",
		"From the workshop of Artificer Innovations, LLC",
		"Tinkered into existence by Artificer Innovations, LLC",
	];

	let taglineIndex = 0;
	let interval: ReturnType<typeof setInterval>;

	onMount(() => {
		interval = setInterval(() => {
			taglineIndex = (taglineIndex + 1) % taglines.length;
		}, 5000);
	});

	onDestroy(() => clearInterval(interval));
</script>

<div class="credit">
	{#key taglineIndex}
		<span class="tagline" transition:fade>{taglines[taglineIndex]}</span>
	{/key}
</div>

<style>
	.credit {
		font-weight: 400;
		color: white;
		opacity: 0.8;
		font-size: x-small;
		width: 100%;
		position: relative;
		display: flex;
		justify-content: center;
		text-align: center;
		min-height: 1em;
	}

	.credit .tagline {
		position: absolute;
		left: 0;
		right: 0;
		width: 100%;
	}
</style>
